import React, { createContext, useContext, useState, useRef } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from "@mui/material";

const ConfirmationDialogContext = createContext();

export const useConfirmation = () => useContext(ConfirmationDialogContext);

export const ConfirmationDialogProvider = ({ children }) => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogMessage, setDialogMessage] = useState("");
    const confirmResolve = useRef(null);

    const showConfirmation = (message = "Are you sure?") => {
        setDialogMessage(message);
        setDialogOpen(true);
        return new Promise((resolve) => {
            confirmResolve.current = resolve;
        });
    };

    const handleConfirm = () => {
        setDialogOpen(false);
        if (confirmResolve.current) confirmResolve.current(true);
    };

    const handleCancel = () => {
        setDialogOpen(false);
        if (confirmResolve.current) confirmResolve.current(false);
    };

    return (
        <ConfirmationDialogContext.Provider value={showConfirmation}>
            {children}
            <Dialog open={dialogOpen} onClose={handleCancel}>
                <DialogTitle>Confirmation</DialogTitle>
                <DialogContent>
                    <Typography>{dialogMessage}</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancel} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleConfirm} color="primary">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </ConfirmationDialogContext.Provider>
    );
};
